import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Using Google Fonts CDN for Lato
export const LatoFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2",
    descriptors: { style: "normal", weight: "400" },
  },
  {
    uri: "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh7USSwiPGQ3q5d0.woff2",
    descriptors: { style: "normal", weight: "700" },
  },
  {
    uri: "https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHjxsAXC-qNiXg7Q.woff2",
    descriptors: { style: "italic", weight: "400" },
  },
  {
    uri: "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI5wq_FQftx9897sxZ.woff2",
    descriptors: { style: "italic", weight: "700" },
  },
];